export function AvatarDefault() {
  return (
    <img
      src="https://docs.material-tailwind.com/img/face-2.jpg"
      alt="avatar"
      className="relative inline-block h-12 w-12 !rounded-full  object-cover object-center"
    />
  );
}
